export default function (url, state, context) {
  state.loading = true;
  console.log(url.value);
  if (url.value.indexOf('filter-data/services') === 0)
    state.json = generateServicesFilterData();
  else if (url.value.indexOf('filter-data/applications') === 0)
    state.json = generateApplicationsFilterData();
  else if (url.value.endsWith('filter-data')) state.json = generateFilterData();
  else if (url.value.indexOf('gisogd') === 0)
    state.json = generateGisogdData(url);
  else if (url.value.indexOf('applications') === 0)
    state.json = generateApplicationsData(url);
  else if (url.value.indexOf('documents/urls') === 0 || url.value.indexOf('objects/urls') === 0)
    state.json = generateUrls();
  else if (url.value.indexOf('documents') === 0)
    state.json = generateDocumentsData(url);
  else if (url.value.indexOf('services') === 0)
    state.json = generateServicesData(url);
  else if (url.value.indexOf('objects') === 0)
    state.json = generateObjectsData(url);
  else state.json = {};

  context.emit('fetched', state.json);
  window.setTimeout(() => (state.loading = false), 0);
}
const generateFilterData = function () {
  return {
    territories: [
      { alias: 'tumenmr', name: 'Район 1' },
      { alias: 'tumenmr2', name: 'Район 2' },
      { alias: 'tumenmr3', name: 'Район 3' },
      { alias: 'tumenmr4', name: 'Район 4' },
      { alias: 'tumenmr5', name: 'Район 5' },
      { alias: 'tumenmr6', name: 'Район 6' },
      { alias: 'tumenmr7', name: 'Район 7' },
      { alias: 'tumenmr8', name: 'Район 8' },
      { alias: 'tumenmr9', name: 'Район 9' },
      { alias: 'tumenmr10', name: 'Район 10' },
      { alias: 'tumenmr11', name: 'Район 11' },
      { alias: 'tumenmr12', name: 'Район 12' },
      { alias: 'tumenmr13', name: 'Район 13' },
      { alias: 'tumenmr14', name: 'Район 14' },
      { alias: 'tumenmr15', name: 'Район 15' },
    ],
    minDateAvailable: '2020-01-01',
  };
};
const generateServicesFilterData = function () {
  return {
    ...generateFilterData(),
    serviceTypes: [
      { alias: 'wf1', name: 'Услуга 1' },
      { alias: 'wf2', name: 'Услуга 2' },
      { alias: 'wf3', name: 'Услуга 3' },
    ],
  };
};
const generateApplicationsFilterData = function () {
  return {
    ...generateFilterData(),
    applicationKinds: [
      { alias: 'app1', name: 'Заявление 1' },
      { alias: 'app2', name: 'Заявление 2' },
      { alias: 'app3', name: 'Заявление 3' },
    ],
  };
};
const generateMonths = function () {
  return [
    'янв',
    'фев',
    'мар',
    'апр',
    'май',
    'июн',
    'июл',
    'авг',
    'сен',
    'окт',
    'ноя',
    'дек',
  ];
};
const registered = Math.round(Math.random() * 100 + 100, 0);
const generateGisogdData = function (url) {
  if (url.value.indexOf('document-distribution-by-territory') > 0) {
    const territories = generateFilterData().territories.map((o) => o.name);
    const categories = [];
    const seriesInTerm = [];
    const seriesExpired = [];

    for (let i = 0; i < territories.length; i++) {
      categories.push(territories[i]);
      seriesInTerm.push(Math.round(Math.random() * 100 + 100, 0));
      seriesExpired.push(Math.round(Math.random() * 100 + 10, 0));
    }

    return {
      categories,
      series: [
        { alias: 'InTerm', name: 'В срок', values: seriesInTerm },
        {
          alias: 'Expired',
          name: 'С нарушением сроков',
          values: seriesExpired,
        },
      ],
    };
  } else if (url.value.indexOf('document-distribution-by-period') > 0) {
    const months = generateMonths();
    const categories = [];
    const series = [];

    for (let i = 0; i < 120; i++) {
      categories.push(months[i % 12]);
      series.push(Math.round(Math.random() * 100 + 100, 0));
    }

    return {
      categories: categories,
      series: [
        {
          name: '',
          values: series,
        },
      ],
    };
  } else if (url.value.indexOf('summary') > 0) {
    return {
      registered,
      registeredInTime: Math.round(
        ((registered * Math.random()) / registered) * 100,
        0
      ),
      pending: Math.round(Math.random() * 100 + 100),
      notRegistered: Math.round(Math.random() * 100 + 100),
    };
  } else if (url.value.indexOf('deadline-compliance') > 0) {
    return [{
      values: [ Math.round(Math.random() * 100, 0) ]
    }];
  } else {
    return {
      value: Math.round(Math.random() * 100 + 100, 0),
    };
  }
};
const generateApplicationsData = function (url) {
  if (url.value.indexOf('send-method-total') > 0) {
    const series = [];
    const categories = [];
    const count = 4;
    let remainder = registered;

    for (let i = 0; i < count; i++) {
      const part = Math.round(
        remainder * (i < count - 1 ? Math.random() : 1),
        0
      );

      remainder -= part;

      series.push(part);
      categories.push(`Категория ${i + 1}`);
    }

    return {
      series,
      categories,
    };
  } else if (url.value.indexOf('send-method-by-territory') > 0) {
    const territories = generateFilterData().territories.map((o) => o.name);
    const categories = [];
    const seriesMethod1 = [];
    const seriesMethod2 = [];
    const seriesMethod3 = [];

    for (let i = 0; i < territories.length; i++) {
      categories.push(territories[i]);
      seriesMethod1.push(Math.round(Math.random() * 100 + 100, 0));
      seriesMethod2.push(Math.round(Math.random() * 100 + 10, 0));
      seriesMethod3.push(Math.round(Math.random() * 100 + 100, 0));
    }

    return {
      categories,
      series: [
        { alias: 'Mfc', name: 'МФЦ', values: seriesMethod1 },
        {
          alias: 'Pgu',
          name: 'ЕПГУ',
          values: seriesMethod2,
        },
        {
          alias: 'Other',
          name: 'Остальные',
          values: seriesMethod3,
        },
      ],
    };
  } else if (url.value.indexOf('send-method-by-kind') > 0) {
    const applicationTypes = [
      'Очень длинное название какого неизвестного в проироде типа заявления',
      'Утверждение СРЗУ',
      'Предварительное согласование предоставления ЗУ',
      'Получение ГПЗУ',
      'Продление действия разрешения на строительство',
      'Внесение изменений в разрешение на строительство',
    ];
    const values = [];
    for (let i = 0; i < 6; i++) {
      values.push({
        applicationKind: applicationTypes[Math.floor(Math.random() * applicationTypes.length)],
        applicationsTotal: Math.ceil(Math.random() * 100),
        mfc: Math.ceil(Math.random() * 100),
        pgu: Math.ceil(Math.random() * 100),
        other: Math.ceil(Math.random() * 100)
      });
    }

    return {
      values,
    };
  } else if (url.value.indexOf('send-method-daily-avarage') > 0) {
    return {
      value: 14.7,
    };
  }
};
const generateDocumentsData = function (url) {
  if (url.value.indexOf('valid-document-quantity-by-territory') > 0) {
    const territories = generateFilterData().territories.map((o) => o.name);
    const categories = [];
    const series = [];

    for (let i = 0; i < territories.length; i++) {
      categories.push(territories[i]);
      series.push(Math.round(Math.random() * 100, 0));
    }

    return {
      categories,
      series: [{ values: series }],
    };
  } else if (url.value.indexOf('valid-document-quantity-by-type') > 0) {
    const columns = [
      'Вид документа',
      'Всего документов',
      'Незаполненные обязательные поля',
      'Без территории действия',
      'Без векторных данных',
      'Без приложенных файлов',
      '% качественных документов',
    ];
    const documentTypes = [
      'Очень длинное название какого неизвестного в проироде типа документа',
      'Тип 2',
      'Тип 3',
      'Тип 4',
      'Тип 5',
    ];
    const values = [];

    for (let i = 0; i < 25; i++) {
      values.push({
        documentType: documentTypes[Math.floor(Math.random() * documentTypes.length)],
        documentsTotal: Math.ceil(Math.random() * 100),
        missingRequiredFields: Math.ceil(Math.random() * 100),
        missingDocumentTerritory: Math.ceil(Math.random() * 100),
        missingVectorData: Math.ceil(Math.random() * 100),
        missingFiles: Math.ceil(Math.random() * 100),
        validDocumentsCount: Math.ceil(Math.random() * 100),
      });
    }

    return {
      columns,
      values,
    };
  }
};
const generateServicesData = function (url) {
  const series = [];
  const categories = [];
  const count = 2;
  let remainder = registered;

  if (url.value.indexOf('service-general-indicator') > 0) {
    const total = Math.round(500 * Math.random());
    const rejected = Math.round(total * Math.random());
    const average = 5 * Math.random();

    return {
      total,
      rejected,
      average,
    };
  } else if (url.value.indexOf('service-stage-pass-percent') > 0) {
    for (let i = 0; i < count; i++) {
      const part = Math.round(
        remainder * (i < count - 1 ? Math.random() : 1),
        0
      );

      remainder -= part;

      series.push(part);
    }
    categories.push(`Все этапы пройдены`);
    categories.push(`Отсутствуют некоторые этапы`);

    return {
      series,
      categories,
    };
  } else if (url.value.indexOf('service-delivery-process') > 0) {
    return {
      quantity: 4000,

      registrationDuration: 1.2,
      registrationCompletedQuantity: Math.round(1000 * Math.random()),
      qualitativeRegistrationQuantity: Math.round(1000 * Math.random()),

      preparationDuration: 2.3,
      preparationCompletedQuantity: Math.round(1000 * Math.random()),
      qualitativePreparationQuantity: Math.round(1000 * Math.random()),

      agreementDuration: 0.6,
      agreementCompletedQuantity: Math.round(1000 * Math.random()),
      qualitativeAgreementQuantity: Math.round(1000 * Math.random()),

      resultDuration: 4.7,
      resultCompletedQuantity: Math.round(1000 * Math.random()),
      qualitativeResultQuantity: Math.round(1000 * Math.random()),

      qualitativeByAllConditionsQuantity: Math.round(1000 * Math.random()),
      qualitativeByNotAllConditionsQuantity: Math.round(1000 * Math.random()),
    };
  }
};


const generateObjectsData = function (url) {
  if (url.value.indexOf('valid-object-quantity-by-territory') > 0) {
    const territories = generateFilterData().territories.map((o) => o.name);
    const categories = [];
    const series = [];

    for (let i = 0; i < territories.length; i++) {
      categories.push(territories[i]);
      series.push(Math.round(Math.random() * 100 + 100, 0));
    }

    return {
      categories,
      series: [{ values: series }],
    };
  } else if (url.value.indexOf('valid-object-quantity-by-type') > 0) {
    const columns = [
      'Вид объекта',
      'Всего объектов',
      'Незаполненные обязательные поля',
      'Без векторных данных',
      'Без приложенных файлов',
      '% качественных объектов',
    ];
    const objectTypes = [
      'Очень длинное название какого неизвестного в проироде типа объекта',
      'Тип 2',
      'Тип 3',
      'Тип 4',
      'Тип 5',
    ];
    const values = [];

    for (let i = 0; i < 25; i++) {
      values.push({
        objectType: objectTypes[Math.floor(Math.random() * objectTypes.length)],
        objectsTotal: Math.ceil(Math.random() * 100),
        missingRequiredFields: Math.ceil(Math.random() * 100),
        missingVectorData: Math.ceil(Math.random() * 100),
        missingFiles: i % 3 !== 0 ? Math.ceil(Math.random() * 100) : -1,
        validObjectsCount: Math.ceil(Math.random() * 100),
      });
    }

    return {
      columns,
      values,
    };
  }
};

const generateUrls = function () {
  const urls = [
    {
      "name": "Тип 2",
      "url": "{GEOMETAURL}/?project={schema}&openpp=QGCheckFieldDocRS&ppfilter=DateDoc gt {from} and DateDoc lt {to}"
    },
    {
      "name": "Тип 3",
      "url": "{GEOMETAURL}/?project={schema}&openpp=QGCheckFieldDocRS&ppfilter=DateDoc gt {from} and DateDoc lt {to}"
    },
  ]
     return urls;
  };
